import React, { useEffect } from "react"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { useDispatch, useSelector } from "react-redux"
import { getRoles, deleteRole } from "store/role/role-action"
import { roleAction } from "store/role/role-slice"
import RoleListComponent from "components/Role/list"

const RoleList = () => {
  const dispatch = useDispatch()
  const { data, error, loading } = useSelector(state => state.role)

  // Handle role deletion
  const handleDeleteRole = (roleId) => {
    dispatch(deleteRole(roleId))
  }

  // fetch all roles
  useEffect(() => {
    dispatch(getRoles())

    return () => {
      dispatch(roleAction.resetState())
    }
  }, [])

  return (
    <React.Fragment>
      <Breadcrumbs title={"Admin"} breadcrumbItem={"Roles"} />
      {/* Role List Component */}
      <RoleListComponent 
        data={data} 
        error={error} 
        loading={loading}
        onDeleteRole={handleDeleteRole}
      />
    </React.Fragment>
  )
}

export default RoleList
